<template>
    <div>
        <NetworkStatus/>
        <Navbar v-bind:hideMenu="true" />

        <div class="page-content">
            <h1 class="title">Terms and Conditions for LocalScale</h1>

            <p><b>1. Introduction</b></p>
            
            <p>
                Welcome to LocalScale! These Terms and Conditions (&quot;Terms&quot;) govern
                your use of the local advertising platform provided by LocalScale
                (“LocalScale”) targeting local customers in specific cities and
                zip codes. By using our services, you agree to comply with and be
                bound by these Terms.
                <br/>
                <br/>
                These Terms are entered into between
                Sift Media, Inc., a Delaware Corporation, with offices at 201 W. Main
                Street, Suite 300, PMB 302, Durham, NC 27701, doing business as
                LocalScale and you (the &quot;Customer&quot;), the entity here
                undersigned and further identified in the account creation process as
                of the date of creating an account with LocalScale (the &quot;Effective
                Date&quot;).
            </p>

            <p>
                The individual signing below for the Customer or clicking-through to
                create an account at <a href="http://www.localscale.com/">www.localscale.com</a>
                personally and individually represents and warrants to LocalScale
                that (i) he or she is fully authorized to enter into these Terms on
                behalf of the Customer.
            </p>

            <p>
                By clicking &quot;Create Account&quot; and continuing to use LocalScale,
                Customer agrees to accept and abide by the Terms. Please note that
                LocalScale reserves the right to update these Terms online
                periodically, and it is your responsibility to review and comply with
                any changes made.
            </p>

            <p><b>2. Services Provided</b></p>

            <p>LocalScale offers various subscription tiers that provide Customer with access to local advertising targeting tools and analytics. Customers can choose from the following plans:</p>

            <ul>Up
                <li>
                    <p><b>Starter</b>: $99/month</p>
                    <ul>
                        <li><p>Estimated 30,000 local ad views per month</p></li>
                        <li><p>Estimated 50 to 100 clicks per month</p></li>
                        <li><p>Unlimited City &amp; Zip code targets</p></li>
                        <li><p>Up to 3 ad campaigns</p></li>
                        <li><p>Conversion tracking</p></li>
                    </ul>
                </li>

                <li>
                    <p><b>Entrepreneur</b>: $249/month</p>
                    <ul>
                        <li><p>Estimated 100,000 local ad views per month</p></li>
                        <li><p>Estimated 200 to 250 clicks per month</p></li>
                        <li><p>Unlimited City &amp; Zip code targets</p></li>
                        <li><p>Up to 10 ad campaigns</p></li>
                        <li><p>Conversion tracking</p></li>
                    </ul>
                </li>

                <li>
                    <p><b>Professional</b>: $499/month</p>
                    <ul>
                        <li><p>Estimated 225,000 local ad views per month</p></li>
                        <li><p>Estimated 400 to 500 clicks per month</p></li>
                        <li><p>Unlimited City &amp; Zip code targets</p></li>
                        <li><p>Up to 20 ad campaigns</p></li>
                        <li><p>Conversion tracking</p></li>
                    </ul>
                </li>

                <li>
                    <p><b>Enterprise</b>:$999/month</p>
                    <ul>
                        <li><p>Estimated 500,000 local ad views per month</p></li>
                        <li><p>Estimated 750 to 1000 clicks per month</p></li>
                        <li><p>Unlimited City &amp; Zip code targets</p></li>
                        <li><p>Unlimited ad campaigns</p></li>
                        <li><p>Conversion tracking</p></li>
                    </ul>
                </li>

                <li>
                    <p><b>Custom</b>:
                    Higher tier for larger businesses seeking even greater local scale,
                    with an agreed upon monthly subscription price for a higher number
                    of estimated local ad views and clicks per month.</p>
                </li>
            </ul>

            <p>
                The monthly number of ad views and clicks are estimates,
                which are not guaranteed and could vary significantly depending on
                the cities and zip codes that the Customer chooses, their ad
                creatives, and their website or landing page. LocalScale uses its
                best efforts to target the Advertisements (the “Advertisements”)
                to the Cities and Zip Codes chosen by the Customer, but this is not
                guaranteed because LocalScale relies on geolocation information from
                third-parties including RTB Exchanges (such as Google, Magnite, and
                others) and Publishers (the websites and apps where LocalScale
                displays Advertisements).
            </p>

            <p><b>3. Subscription Fees and Payment</b></p>

            <p>Customer agrees to pay the monthly subscription fee corresponding to their selected plan. The fees are as follows:</p>

            <ul>
                <li><p>Starter: $99 per month</p></li>
                <li><p>Entrepreneur: $249 per month</p></li>
                <li><p>Professional: $499 per month</p></li>
                <li><p>Enterprise: $999 per month</p></li>
                <li><p>Custom: Based on individual agreements agreed in writing</p></li>
            </ul>

            <p>
                Customers have the ability to pause or cancel the service at any time. The
                service will be billed on a monthly basis by credit card payment,
                starting from the date the Customer signs up for the service and will
                automatically renew on a monthly basis unless the Customer cancels
                prior to the renewal date. For example, if the Customer signs up on
                the 22nd day of the month, the service will automatically renew on
                the 22nd day of each subsequent month unless the Customer cancels
                prior to the 22nd day of the month.
            </p>

            <p><b>4. Refund Policy</b></p>

            <p>
                If the Customer cancels, they are not eligible for a refund for any partial month period.
                If a Customer is not satisfied with the LocalScale service, their sole remedy is to cancel the service,
                and no refunds are offered for any reason. However, LocalScale reserves the right to disapprove any creatives
                or landing pages for any reason. In such limited cases, LocalScale may issue a refund to the Customer.
                For further assistance, Customers may contact LocalScale support at support@localscale.com.
            </p>

            <p><b>5. Creatives License</b></p>

            <p>
                As part of the LocalScale platform, Customers will upload logos, images,
                and other creative assets as well as write text advertising copy to
                build their LocalScale Advertisements. Customers grant LocalScale a
                non-exclusive, royalty-free, worldwide License (the “License”) to
                use, reproduce, modify, and display the ad creatives submitted by the
                Customer for the purpose of delivering the advertising services. This
                License extends to Sift Media’s partners including RTB Exchanges,
                Publishers, and Hosting Providers that are part of the advertising
                ecosystem for serving and displaying such Advertisements.
            </p>

            <p><b>6. Representations &amp; Limitation on Liability</b></p>

            <p>
                Each party represents and warrants the other party that: (a) it has the
                full corporate right, power and authority to enter into the Terms, to
                grant the licenses granted hereunder and to perform the acts required
                of it hereunder; (b) the execution of the Terms by it and the
                performance of its obligations and duties hereunder, do not and will
                not violate any agreement to which it is a party or by which it is
                otherwise bound; (c) when executed and delivered, the Terms will
                constitute the legal, valid and binding obligation of each party,
                enforceable against each party in accordance with its terms; and
                Customer represents that (A) its Advertisements including among
                others all content shown in the Advertisements and text, images or
                any other graphics provided by Customer: (i) do not and will not
                infringe upon, misappropriate or otherwise violate the intellectual
                property rights of any third party and that the Advertisements and
                any accompanying documentation and its marketing material do not and
                will not include any obscene, libelous, defamatory, illegal, or
                otherwise offensive material, or in any context that harms the
                goodwill or reputation of LocalScale or that disparages or brings
                LocalScale or its business partners into disrepute; (B) it will not
                and will not allow any third party through its Advertisements or
                otherwise to exploit LocalScale’s services except for the limited
                expressed purpose of these Terms.
            </p>

            <p>
                In no event shall either party be liable to the other party for any
                incidental, indirect, special, exemplary, or consequential damages
                including, but not limited to, damages for loss of profits, business
                interruption, loss of information, and the like, in each case even if
                such party has been advised of the possibility of such damages.
                Without derogating from any of the foregoing, LocalScale’s total
                aggregate liability under these Terms, if any, to the Customer or any
                other person or entity, in connection with any claim relating to
                these Terms, including any services provided by or on behalf of
                Customer, will be limited to an amount equal to the lower of (i)
                US$10,000 or (ii) the amount received by LocalScale under these Terms
                during the 30 day period immediately preceding the date of the claim.
                The existence of one or more claims will not enlarge this limit. This
                section shall survive the cancellation or termination of these Terms.
            </p>

            <p>
                No action arising under or relating to these Terms, regardless of its
                form, may be brought by either party more than six (6) months after
                the cause of action has accrued and in any event no later than 3
                months after the termination of these Terms, except for an action for
                non-payment brought by LocalScale. The foregoing limitations shall
                apply notwithstanding any failure of essential purpose of any limited
                remedy and are fundamental elements of the bargain between the
                parties.
            </p>

            <p>
                Subject to the limitation of liability herein, each party (the &quot;Indemnifying
                Party&quot;) will defend, indemnify and hold harmless the other party
                (the &quot;Indemnified Party&quot;) from and against any and all
                liabilities, losses, damages, costs and expenses (including legal
                fees and expenses) associated with any claim of action brought
                against the Indemnified Party arising out of or related to a breach
                by the Indemnifying Party of its representations and warranties as
                set forth in these Terms. The foregoing indemnity obligations shall
                apply provided that the Indemnified Party (i) promptly notifies the
                Indemnifying Party in writing of any such claim (provided that
                failure to provide timely notice will not alter the Indemnifying
                Party's obligations except to the extent that it is materially
                prejudiced thereby), (ii) allows the Indemnifying Party, at its sole
                expense, to direct the defense of such claim, (iii) gives the
                Indemnifying Party full information and reasonable assistance which
                is available to the Indemnified Party and is useful or necessary to
                defend such claim, and (iv) does not enter into any settlement of any
                such claim, without the Indemnifying Party's consent, which shall not
                be unreasonably withheld.
            </p>

            <p><b>7. Business Operations</b></p>

            <p>LocalScale will make reasonable commercial efforts to maintain its service
                operational 24/7. However, the parties agree it is normal to have a
                certain amount of system downtime and agree not to hold each other
                liable for any of the consequences of such interruptions.
            </p>

            <p><b>8. Relationships of Parties</b></p>

            <p>
                The relationships of the parties to these Terms shall be solely that of
                independent contractors, and nothing contained in these Terms shall
                be construed otherwise. Nothing contained in these Terms, nor any
                action taken by any party to these Terms, shall be deemed to
                constitute either party (or any of such party's employees, agents, or
                representatives) an employee, or legal representative of the other
                party, nor to create any joint venture, association, or syndication
                among or between the parties.
            </p>

            <p><b>9. Force Majeure</b></p>

            <p>
                Neither party shall be liable by reason of any failure or delay in the
                performance of its obligations hereunder for any cause beyond the
                reasonable control of such party, including but not limited to
                electrical outages, failure of Internet service providers, riots,
                insurrection, war (or similar), fires, flood, earthquakes,
                explosions, and other acts of God.
            </p>

            <p><b>10. General</b></p>

            <p>
                These Terms contain the entire agreement between the parties and supersede
                all prior agreements between the parties. Nothing in these Terms is
                intended or will be construed to give any person, other than the
                parties hereto, any legal or equitable right, remedy or claim under
                or in respect of these Terms or any other provision contained herein.
                These Terms may be executed in two counterparts, each of which shall
                constitute an original and the two together shall constitute a single
                agreement. Continued use of the LocalScale service constitutes
                acceptance of the Terms, which LocalScale may update online
                periodically. Whenever possible, each provision of these Terms shall
                be interpreted in such a manner as to be effective and valid under
                applicable law but, if any provision of these Terms is held to be
                invalid, illegal or unenforceable in any respect, such provision will
                be ineffective only to the extent of such invalidity, or
                unenforceability, without invalidating the remainder of these Terms.
            </p>

            <p>
                Any dispute, controversy or claim arising out of, relating to or in
                connection with these Terms, including any question regarding its
                existence, validity or termination, shall be governed by and
                construed and enforced in accordance with the laws of the United
                States of America (without reference to the conflict of laws rules or
                principles thereof), and the parties expressly consent that any
                dispute arising from or out of, or relating to these Terms shall be
                resolved by arbitration in accordance with the American Arbitration
                Association. Unless otherwise agreed by the parties, the seat of
                arbitration shall be Durham, North Carolina and may be conducted by
                video or teleconference. The number of arbitrators shall be one and
                the language of the arbitration shall be English.
            </p>

            <p></p>

            <p><b>Data Processing Agreement (DPA)</b></p>

            <p><b>1. Introduction</b></p>

            <p>This Data Processing Agreement (&quot;DPA&quot;) forms part of the Terms and Conditions between LocalScale (&quot;Processor&quot;) and the Customer (&quot;Controller&quot;) and governs the processing of personal data in connection with the provision of services by LocalScale.</p>

            <p><b>2. Definitions</b></p>

            <ul>
                <li><p><b>Controller</b>: The entity that determines the purposes and means of processing personal data.</p></li>
                <li><p><b>Processor</b>: The entity that processes personal data on behalf of the Controller.</p></li>
                <li><p><b>Personal Data</b>: Any information relating to an identified or identifiable natural person.</p></li>
                <li><p><b>Data Subject</b>: The individual to whom personal data relates.</p></li>
                <li><p><b>Processing</b>: Any operation or set of operations performed on personal data.</p></li>
            </ul>

            <p><b>3. Processing of Personal Data</b></p>

            <p>3.1 <b>Scope and Purpose</b>: LocalScale will process personal data as necessary to provide the services to the Customer, in accordance with the Customer's instructions as outlined in the Terms and this DPA.</p>

            <p>3.2 <b>Duration</b>: The processing of personal data will continue for the duration of the Customer's subscription to LocalScale's services.</p>

            <p><b>4 Obligations of the Processor</b></p>

            <p>4.1 <b>Compliance</b>: LocalScale will process personal data in compliance with applicable data protection laws, including but not limited to the GDPR and CCPA.</p>

            <p>4.2 <b>Confidentiality</b>: LocalScale will ensure that personnel authorized to process personal data have committed themselves to confidentiality or are under an appropriate statutory obligation of confidentiality.</p>

            <p>4.3 <b>Security Measures</b>: LocalScale will implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk.</p>

            <p><b>5. Sub-processors</b></p>

            <p>LocalScale may engage sub-processors to process personal data on behalf of the Customer. LocalScale will ensure sub-processors are bound by data protection obligations compatible with those of LocalScale.</p>

            <p><b>6. Data Subject Rights</b></p>

            <p>LocalScale will assist the Customer in responding to requests from data subjects to exercise their rights under applicable data protection laws,
                including rights of access, correction, deletion, and objection.</p>

            <p><b>7. Data Breach Notification</b></p>

            <p>In the event of a personal data breach, LocalScale will notify the Customer without undue delay and provide reasonable assistance to the Customer in managing the breach.</p>

            <p><b>8. Data Protection Impact Assessments</b></p>

            <p>LocalScale will assist the Customer in conducting data protection impact assessments and prior consultations with supervisory authorities as required by law.</p>

            <p><b>9. Deletion or Return of Data</b></p>

            <p>Upon termination of the services, LocalScale will delete or return all personal data to the Customer, except where retention is required by applicable law.</p>

            <p>
                <br/>
                <br/>
            </p>
        </div>

        <Footer/>
    </div>
</template>

<style>
    .page-content {
        margin: 50px 100px 40px 100px;
        text-align: left;
    }
    h2 {
        font-weight: bold;
        font-size: 18px;
    }
    p, ul {
        margin-bottom: 20px;
    }
    li {
        margin: 0 0 20px 20px;
    }
</style>

<script>
    import Navbar from "../components/Navbar";
    import NetworkStatus from "../components/NetworkStatus.vue";
    import Footer from "../components/Footer";

    export default {
        components: {
            Navbar, NetworkStatus, Footer
        }
    }
</script>